<template lang="html">
  <div class="component-wrapper">
    <div class="flex-box">
      <div class="filters">
            <tl-select
            label="Department"
            labelText="departmentName"
            :value="params.departmentId" 
            :options="departmentsData"
            :reduce="department => `${department.departmentName}`"
            @change="(val)=>changeDepartmentVal(val)"/>
            <tl-select 
            label="Location"
            labelText="locationName"
            :value="params.loid" 
            :options="locationsData"
            :reduce="location => `${location.locationName}`"
            @change="(val)=>changeLocationVal(val)"/>
            <tl-select 
            label="Cost Centre"
            labelText="centreName"
            :value="params.ccid" 
            :options="costCentersData"
            :reduce="costCenter => `${costCenter.centreName}`"
            @change="(val)=>changeCostCenterVal(val)"/>
            <tl-select 
            label="Designation"
            labelText="designationName"
            :value="params.designationId" 
            :options="designationsData"
            :reduce="designation => `${designation.designationName}`"
            @change="(val)=>changeDesignationVal(val)"/>
            <div>
          </div>
          <btn text="More Filters" type="secondary" class="margintop-10" @click="saveModalData"/>
        </div>
      </div>
      <div class="search-bar">
        <tl-search class="half-width" @change="filterData"/>
        <div class="sort-by">
          <span> Sort By: </span>
          <tl-select 
            class="custom-width"
            labelText="centreName"
            :value="params.ccid" 
            :options="costCentersData"
            :reduce="costCenter => `${costCenter.centreName}`"
            @change="(val)=>changeCostCenterVal(val)"/>
        </div>
    </div>
     <data-table 
        :columns="employeeTableColumns" 
        :tableData="employeeData" 
        :checkbox="true" 
        :withForm="false" 
        @editStart="initEditStart"
        @delete="deleteItem" 
        @update="updateItem"
        :showinrow="false"
        :search="search">
        <template v-slot:rowcontent="slotprops">
           <img class="sm-img" v-if="slotprops.value.column.key=='imgSrc'" :src="slotprops.value.record[slotprops.value.column.key]"/>
           <p v-if="slotprops.value.column.key!='imgSrc'">{{slotprops.value.record[slotprops.value.column.key]}}</p>
            <!-- dropdown section starts here -->
            <div class="action-section" v-if="slotprops.value.column.key=='action'"> 
              <img src="@/assets/group-2.png" @click="dropdown(slotprops.value)" alt="actionIcon">
              <ul class="action-menu" v-show="employeeData[slotprops.value.index].showDropDown" >
                  <li><span class="" @click="changeESSStatus(slotprops.value.record)">Change ESS Status </span></li>
                  <li> <span class="" @click="resetESSPassword(slotprops.value.record)">Reset ESS Password </span></li>
                  <li><span class="" @click="createESSLogin(slotprops.value.record)">Create ESS Login </span></li>
              </ul>
            </div>
           <!-- dropdown section ends here -->
        </template>

     </data-table>
        

  <!-- EMployee Detail Modal -->
  <div class="modal custom-modal" v-if="changeESSStatusModal">
    <div class="modal-content modal-sm">
      <div class="modal-header">
          <h3>Change ESS Status</h3>
      </div>
      <div class="modal-body">
        <div class="threeColumnGrid">
           <div class="emp-img">
             <img src="@/assets/user.svg">
           </div>
           <div class="employee-Details">
             <div class="empName">
               <label>{{this.essStatusModal.fullname}}</label>
             </div>
             <div class="empcode">
               <label>{{this.essStatusModal.code}}</label>
             </div>
             <div class="empcode">
               <label>{{this.essStatusModal.offiEmailId}}</label>
             </div>
             <div class="essStatus">
                <div class="label-text">Ess Status</div>
                <div class="radio-group radio-margin-top">
                  <input type="radio" id="active" name="Variable" value="true" v-model="this.essStatusModal.enableEss">
                  <label for="active">Active</label>
                  <input type="radio" id="deactive" name="Variable" value="false" v-model="this.essStatusModal.enableEss">
                  <label for="deactive">DeActive</label>
                </div>
            </div>
             <div class="essStatus">
               <div class="label-text">Effective Date</div>
               <date-picker @datevalue="(val)=>this.essStatusModal.effectiveDate=val" :value="this.essStatusModal.effectiveDate"/>
             </div>
           </div>
        </div>
        <div class="row justify-content-center paddingtop-10p">
            <btn-grp>
              <btn text="Cancel" type="secondary" @click="cancelModal"/>
              <btn text="Save" type="primary" @click="saveModalData"/>
            </btn-grp>
        </div>
      </div>
    </div>
  </div>
 </div>
</template>


<script>
  import { mapState, mapActions, mapGetters } from "vuex";
  export default {
    data() {
      return {
        changeESSStatusModal: false,
        employeeDetails: {},
        search: "",
        formData: {},
        costCenter: "",
        showDropdown: false,
        le_id: "1580822c-764b-11e9-8f9e-2a86e4085a59", 
        employeeTableColumns: [
          {
            label: "",
            key: "imgSrc"
          },
          {
            label: "Code",
            key: "code"
          },
          {
            label: "Name",
            key: "fullname"
          },
          {
            label: "Department",
            key: "department"
          },
          {
            label: "Email ID",
            key: "offiEmailId"
          },
          {
            label: "Location",
            key: "location"
          },
        ],
        employeeData: [
          {
            id:1,
            showDropDown: false,
            code: "TL001",
            fullname: "Nelle Foster",
            department: "IT",
            offiEmailId: "nellefoster@gmail.com",
            location: "Hyderabad",
            enableEss: "Active",
            imgSrc: require("@/assets/user.svg"),
            action: ""

          },
          {
            id:2,
            showDropDown: false,
            code: "TL002",
            fullname: "Derrick Perry",
            department: "IT",
            offiEmailId: "derrick@gmail.com",
            location: "Hyderabad",
            enableEss: "Active",
            imgSrc: require("@/assets/user.svg"),
            action: ""
          },
          {
            id:3,
            showDropDown: false,
            code: "TL003",
            fullname: "Lucas Singleton",
            department: "IT",
            offiEmailId: "lukasSigle@gmail.com",
            location: "Hyderabad",
            enableEss: "Active",
            imgSrc: require("@/assets/user.svg"),
            action: ""
          }
        ],
        filtersData:[],
        departmentsData: [{
          id:1,
          departmentName:"IT"},
          {
          id:2,
          departmentName:"Finance"},
          {
          id:3,
          departmentName:"Home"},{
          id:4,
          departmentName:"Defence",
        }],
        locationsData: [{
          id:1,
          locationName:"Hyderabad"},{
          id:2,
          locationName:"Bangalore"},{
          id:3,
          locationName:"Chennai"},{
          id:4,
          locationName:"Mumbai"
        }],
        costCentersData: [{
          id:1,
          centreName:"CC 1"},{
          id:2,
          centreName:"CC 2"},{
          id:3,
          centreName:"CC 3"},{
          id:4,
          centreName:"CC 4"
        }],
        designationsData: [{
          id:1,
          designationName:"Manager"},{
          id:2,
          designationName:"Associate"},{
          id:3,
          designationName:"Sub-Associate"},{
          id:4,
          designationName:"Trainee"
        }],
        params: {
          le_id: this.le_id,
        },
        essStatusModal:{

        }
      };
    },
    mounted() {
      //console.log("New component ESS Management mounted.");
    },
    activated: function() {
      this.fetchdepartMents();
      this.fetchlocations();
      this.fetchCostCentres();
      this.fetchdesignation();
      this.fetchEmplDetails();
    },
    computed: {
      orgId() {
        
        return this.$store.getters["onboard/getOrgId"];
      },
      ...mapGetters({
        getleid:'onboard/legal_entities/legal_entity_ID',
      }),
      le_id() {
          if(this.$route.params.entity_index)
            return this.getleid(this.$route.params.entity_index)
          else
            return this.getleid(0)
        }
      },
    methods: {
      ...mapActions({
        act_departmentList: "onboard/departments/fetchAll",
        act_locationList: "onboard/locations/fetchAll",
        act_fetchCostCenters: "onboard/cost_centres/fetchAll",
        act_designationList: "onboard/designations/fetchAll",
        act_fetchAllEmployees: "dashboard/payroll/employees/fetchAll",
        act_changeEmployeeESSStatus: "dashboard/oganisation/essManagement/update"
      }),

      async fetchdepartMents() {
        try {
          let res = await this.act_departmentList(this.le_id);
          //this.departmentsData =
          
          let dataArr = res.data.rows;
          if (dataArr.length){
              this.departmentData = res.data;
          }
          
          //console.log("fetchdepartMents:", res);
        } catch (err) {
          //console.log(err);
        }
      },

      async fetchlocations() {
        try {
          let res = await this.act_locationList(this.le_id);
          //  this.locationsData =
          
          let dataArr = res.data;
          if (dataArr.length){
            this.locationsData = res.data;
          }
          
          //console.log("fetchlocations:", res);
        } catch (err) {
          //console.log(err);
        }
      },

      async fetchCostCentres() {
        try {
           let res = await this.act_fetchCostCenters(this.le_id);
          //  this.costCentersData =
          let dataArr = res.data.rows;
          if (dataArr.length){
           this.costCentersData = dataArr;
          }
          //console.log("fetchCostCentres:", res);
        } catch (err) {
          //console.log(err);
        }
      },

      async fetchdesignation() {
        try {
          let res = await this.act_designationList(this.le_id);
          //  this.designationsData =
          let dataArr = res.data.rows;
          if (dataArr.length){
           this.designationsData = res.data;
          };
          //console.log("fetchdesignation:", res);
        } catch (err) {
          //console.log(err);
        }
      },

      async fetchEmplDetails() {
        try {
          
          let res = await this.act_fetchAllEmployees(this.params);
          let dataArr = res.data.rows;
          if (dataArr.length){
            this.employeeData = res.data.rows;
          };
          //console.log("fetchEmplDetails:", res);
        } catch (err) {
          //console.log(err);
        }
      },

      cancelModal() {
        this.changeESSStatusModal = false;
      },
      async saveModalData(){
        
        //console.log("saveModalData:",this.essStatusModal);

        let obj  = {
         emp_id: this.essStatusModal.id,
         email_id: this.essStatusModal.offiEmailId,
         status: this.essStatusModal.enableEss,
         effective_date: this.essStatusModal.effective_date,
        }
        this.changeESSStatusModal = false;
        //console.log("obj:",obj);
        try {

          let res = await this.act_changeEmployeeESSStatus(obj);
          // let dataArr = res.data.rows;
          // if (dataArr.length){
          //     this.departmentData = res.data;
          // }
          //console.log("saveModalData:", res);
        } catch (err) {
          //console.log(err);
        }
      },
      dropdown(slots) {
          let idx = this.employeeData.findIndex(obj => {
          return obj.id == slots.index + 1;
          });
          this.employeeData.forEach((data, index) => {
          if (index != idx) {
          data.showDropDown = false;
          }
          });
          if (idx > -1) {
          this.employeeData[slots.index].showDropDown = !this.employeeData[slots.index].showDropDown;
          }
      },
      initEditStart(record) {
        //console.log("record", record);
        this.employeeDetails = record;
        this.changeESSStatusModal = true;
      },
      filterData(searchText) {
        this.search = searchText;
      },
      deleteItem(record) {},
      updateItem(record) {},


      changeFilterVal(val){
        //console.log('changeFilterVal:',val);
      },
      changeDepartmentVal(val){
        //console.log('changeDepartmentVal:',val);
        //console.log("params:",this.params);
        this.fetchEmplDetails();

      },
      changeLocationVal(val){
        //console.log('changeLocationVal:',val);
        
        if (val){
          this.params.loid = val.id;
          this.params.le_id = this.le_id;
          //console.log("params:",this.params);
          this.fetchEmplDetails();
        }
      },
      changeCostCenterVal(val){
        //console.log('changeCostCenterVal:',val);
        //console.log("params:",this.params);
        this.fetchEmplDetails();
      },
      changeDesignationVal(val){
        //console.log('changeDesignationVal:',val);
        //console.log("params:",this.params);
        this.fetchEmplDetails();
      },

      essStatusVal(bool){
        return bool ? "Active" : "In-Active";
      },

      changeESSStatus(record){
        //console.log("changeESSStatus:",record);
        
        this.essStatusModal.fullname = record.fullname;
        this.essStatusModal.code = record.code;
        this.essStatusModal.id = record.id;
        this.essStatusModal.enableEss = record.enableEss;
        this.essStatusModal.offiEmailId = record.offiEmailId;

        this.changeESSStatusModal = true;

      },

      resetESSPassword(record){
        //console.log("resetESSPassword:",record);
      },

      createESSLogin(record){
        //console.log("createESSLogin:",record);
          this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/essLogin`
          }); 
      },


    },
  };
</script>

<style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common
@import "@/scss/dashboard/content/_section.scss"; // Content Section
.nav {
  margin-top: 1.7%;
  color: #555555;
  font-size: 11px;
}
.empName label {
  font-size: 16px;
  color: #646464;
  margin-bottom: 4px;
}
.empcode label {
  font-size: 14px;
  color: #878787;
}
[type="radio"]:not(:checked) + label {
  position: relative;
  padding-left: 21px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: #646464;
  margin-right: 32px;
}
.main-header {
  color: #6d6d6d;
  margin-top: 37px;
  font-size: 16px;
}
.half-width {
  width: 26.7%;
}
.filters-section {
  display: flex;
  align-items: flex-end;
  margin-top: 30px;
  // overflow: scroll;
  *:nth-child(1) {
    margin-right: 10px;
  }
}
.sm-img {
  width: 35%;
}
.ver-line {
  border-right: solid 1px #30b6bc;
  padding-top: 10px;
}
.emp-img {
  width: auto;
  text-align: center;
}
.component-wrapper {
  padding: 14px;
}
.custom-width-100 {
  width: 100px;
}

.selectdiv {
  select {
    max-width: 200px;
    border-radius: 4px;
    outline: 0;
    font-size: 14px;
    color: #9c9c9c;
    border: 1px solid #dadada;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    /* SVG background image */
    // background: url("@/assets/stroke-1.png");
    background-size: 12px;
    background-position: calc(100% - 10px) center;
    background-repeat: no-repeat;

    option {
      color: #9c9c9c;
      font-size: 12px;
    }
  }
  span {
    color: #b3b3b3;
    font-size: 12px;
  }
}
.filters-button {
  margin-top: 20px;
  width: 95px;
  height: 35px;
  cursor: pointer;
  font-size: 12px;
  border-radius: 4px;
  color: #555555;
  border: 1px solid #37c6c0;
}
.search-bar {
  padding: 30px 0px 30px 0px;
  display: flex;
}
.essStatus {
  margin: 30px 0px;
  .label-text {
    font-size: 12px;
    font-weight: 500 !important;
    color: #8d8d8d !important;
    height: 15px !important;
  }
}
.export-section {
  margin-left: 6%;
  margin-top: 5px;
  align-items: center;
  display: flex;
  justify-content: flex-end;
}
.export-button {
  width: 60px;
  height: 20px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 1px solid #5d409f;
  color: #5d409f;
  margin-left: 3px;
}
.export-section {
  margin-left: 26%;
  align-items: center;
  display: flex;
}
.export-button {
  width: 60px;
  height: 20px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 1px solid #5d409f;
  color: #5d409f;
  margin-left: 3px;
}
.sort-by {
  display: flex;
  margin-left: auto;
  span {
    margin-right: 10px;
    margin-top: 10px;
    color: #b3b3b3;
    font-size: 12px;
  }
}
.custom-width{
  min-width: 200px;
}
.side-actions {
  margin-left: 10px;
  margin-top: 10px;
  img {
    cursor: pointer;
    margin-right: 5px;
    margin-left: 5px;
  }
}
.flex-box {
  display: flex;
  justify-content: space-between;
}

.action-section {
  margin: 0px;
  text-align: center;

  img {
    width: auto;
  }
  .action-menu {
    top: 0px;
    right: 54px;
    left: -182px;
    li {
      padding: 0px;
      padding: 10px 25px;
      font-weight: 500;
      &:not(:last-child) {
        border-bottom: solid 1px #97979759;
      }
    }
  }
}

.employee-cards {
  padding: 30px 0 0 10px;
}
</style>
